import { Step } from "./Onestop";
import { Button, List, ListItem, ListContent, Icon, Popup, Dimmer } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { getTeamAssets } from "../common/apiClient";
import { getStorage, updateStorage } from "./Onestop";
import './Onestop.css'
import { useEffect, useState } from "react";
import { LoadingWrapper } from "../common";

export const ChecklistStep = props => {
    const storage = getStorage()
    const [assetsWithChecklists, setAssetsWithChecklists] = useState([])
    const [checklistsCompleted, setChecklistsCompleted] = useState(storage && storage.checklistsCompleted)
    const [loaded, setLoaded] = useState(false)
    const [dimming, setDimming] = useState(false)
    const navigate = useNavigate()

    async function getChecklists() {
        setLoaded(false)
        const teamAssets = await getTeamAssets(props.team.id)
        setAssetsWithChecklists(teamAssets.filter((asset) => asset.checklistExists))
        setLoaded(true)
    }

    function didChecklistsComplete() {
        const wasAlreadyFinished = checklistsCompleted
        if(!wasAlreadyFinished) {
            setDimming(true)
        }
        setChecklistsCompleted(true)
        updateStorage('checklistsCompleted', true)
        setTimeout(() => {
            setDimming(false)
            props.nextStep()
        }, wasAlreadyFinished ? 0 : 750)
    }

    useEffect(() => {
        if (props.team.id) {
            getChecklists()
        }
    }, [props.team])

    return <LoadingWrapper loading={!loaded}>
        <Step completed={checklistsCompleted}>
            <div className='onestop-header'><span style={{ textDecoration: "underline" }}>Complete or incomplete</span> the following checklists for the assets you plan on using.</div>
            {assetsWithChecklists.length ? <List relaxed celled style={{ width: "fit-content", minWidth: "10rem" }}>
                {assetsWithChecklists.map((asset, i) => {
                    const assetName = asset['name']
                    const assetId = asset['id']
                    const assetVerifiedToday = (new Date(asset['checklistVerifiedOn'])).getDate() === (new Date()).getDate()
                    return (
                        <div key={i} className='list-item' style={{ padding: "1rem", width: "100%", display: "block" }}>
                            <ListItem key={assetId}>
                                <ListContent onClick={() => {navigate('/assets/' + assetId + '/checklist')}} style={{ fontWeight: "bold", width: "100%" }} as='a'>
                                    <div style={{ display: "flex", justifyContent: "space-between", textAlign: "left", width: "100%" }}>
                                        {assetName}
                                        <Popup
                                            content={<>
                                                <Icon className="check" color="green" /> if completed today,
                                                <Icon className="times" color="red" /> if not
                                            </>}
                                            trigger={<Icon style={{ marginLeft: "1rem" }} className={assetVerifiedToday ? "check" : "times"}
                                                color={assetVerifiedToday ? "green" : "red"} />} />
                                    </div>
                                </ListContent>
                            </ListItem>
                        </div>)
                })}
            </List> : <div className="onestop-content">You do not have any assets with checklists.</div>}
            <div className="divider-bottom" />
            <Button style={{ backgroundColor: checklistsCompleted ? "lightgreen" : "" }} onClick={didChecklistsComplete}>Done</Button>

            <Dimmer active={dimming} inverted>
                <Icon className="check" color="green" size="huge" />
            </Dimmer>
        </Step>
    </LoadingWrapper>
}